import { ChakraProvider } from "@chakra-ui/react";
import { useCustomTheme } from "../../contexts/CustomThemeContext";
import { createChakraTheme } from "./createChakraTheme";


const ThemedChakraProvider = ({ children }: { children: React.ReactNode; }) => {
    const { theme } = useCustomTheme();

    return (
        <ChakraProvider theme={createChakraTheme(theme)}>
            {children}
        </ChakraProvider>
    );
};

export default ThemedChakraProvider;
